import React, { Component } from "react";
import { Select } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { generateYearList } from "../../../../utils";
import { PAYMENTPAGE } from "npmlinks-constants";

class ExpYear extends Component {
  static getList(item) {
    return (
      <li className="nw-common-selectlist" key={item}>
        {item}
      </li>
    );
  }
  constructor(props) {
    super(props);
    this.state = {
      selectSelectedValue: PAYMENTPAGE.DEFAULTSELECTED_EXPYEAR,
      inpList: generateYearList(
        this.props.currentYear,
        this.props.currentYear + PAYMENTPAGE.YEARLENGTH,
      ),
    };
    this.getSelectSelection = this.getSelectSelection.bind(this);
  }

  getSelectSelection(selectedValue) {
    this.setState({
      selectSelectedValue: selectedValue,
    });
    this.props.handleSubmit({ expYear: selectedValue });
  }

  render() {
    const { inpList, selectSelectedValue } = this.state;
    return (
      <Select
        className="nwc-grid-col-sm-2 nw-expyear-dropdown nw-common-select"
        selectedValue={selectSelectedValue}
        inpList={inpList}
        getSelection={this.getSelectSelection}
        renderList={ExpYear.getList}
      />
    );
  }
}
ExpYear.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  currentYear: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ExpYear,
  component: ExpYear,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/CreditCard/ExpYear/index.js